import { render, staticRenderFns } from "./mainportal.vue?vue&type=template&id=4ae81ba9&scoped=true&"
import script from "./mainportal.vue?vue&type=script&lang=js&"
export * from "./mainportal.vue?vue&type=script&lang=js&"
import style0 from "./mainportal.vue?vue&type=style&index=0&id=4ae81ba9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae81ba9",
  null
  
)

export default component.exports